// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"Uploader_dropzone__1Kf5f","active":"Uploader_active__1z6QT"};